import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const DELETE_PAGE: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation deletePage($input: DeletePageInput!) {
    deletePage(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
